module.exports = __webpack_public_path__ + "img/square-phone.fbe97860.svg";